import toast from "react-hot-toast";

import { stripHtml } from "string-strip-html";

import markdown from "@wcj/markdown-to-html";

import { TEXT_HTML_MIME_TYPE, TEXT_PLAIN_MIME_TYPE } from "@virtual-brain-lib/types";
import { cleanArtifactTags, cleanSourceTags } from "@virtual-brain-lib/utils-text-processing";

export function cleanMarkdownForCopy(text: string): string {
	return cleanArtifactTags(cleanSourceTags(text));
}

function enhanceTables(markdown: string): string {
	let result = markdown
		.replace(
			/<table>/gi,
			`<table border="0" cellpadding="8" cellspacing="0" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif; font-size: 10pt; margin: 16px 0;">`,
		)
		.replace(
			/<th>/gi,
			`<th style="background-color: #4a86e8; color: white; border: 1px solid #3367d6; padding: 10px 12px; text-align: left; font-weight: bold;">`,
		)
		.replace(
			/<td>/gi,
			`<td style="border: 1px solid #dadce0; padding: 8px 12px; vertical-align: top;">`,
		);

	let rowIndex = 0;

	result = result.replace(/<tr>/gi, () => {
		const bgColor = rowIndex % 2 === 0 ? "#ffffff" : "#f8f9fa";

		rowIndex++;

		return `<tr style="background-color: ${bgColor};">`;
	});

	result = result.replace(/<table/gi, () => {
		rowIndex = 0;

		return "<table";
	});

	return result;
}

export async function copyMarkdownToClipboard(markdownText: string, successText?: string) {
	const cleanedContent = cleanMarkdownForCopy(markdownText ?? "");

	try {
		const formatedContent = enhanceTables(markdown(cleanedContent) as string);

		const blobRich = new Blob([formatedContent], { type: TEXT_HTML_MIME_TYPE });
		const plainText = stripHtml(formatedContent).result;
		const blobPlain = new Blob([plainText], { type: TEXT_PLAIN_MIME_TYPE });

		const data = [
			new ClipboardItem({
				[TEXT_HTML_MIME_TYPE]: blobRich,
				[TEXT_PLAIN_MIME_TYPE]: blobPlain,
			}),
		];

		await navigator.clipboard.write(data);
	} catch {
		await navigator.clipboard.writeText(cleanedContent);
	}

	if (successText) {
		toast.success(successText);
	}
}

export function copyHtmlToClipboard(html: string, type: "table" | "code", successText?: string) {
	html = html.replaceAll(/<span[^>]*class=["'][^"']*vb-source[^"']*["'][^>]*>.*?<\/span>/gis, "");

	const doc = document.createElement("div");

	doc.innerHTML = html;
	let text = "";

	const table = doc.querySelector("table");

	// TSV format for Slack
	if (table) {
		const rows = Array.from(table.querySelectorAll("tr"));
		const cellsData: string[][] = rows.map((row) =>
			Array.from(row.children).map((cell) =>
				(cell as HTMLElement).innerText.replace(/\s*\n\s*/g, " ").trim(),
			),
		);

		text = cellsData.map((row) => row.join("\t")).join("\n");
		// For code blocks since it can be html code, we want the full text
	} else if (type === "code") {
		text = doc.innerHTML;
	} else {
		text = doc.innerText;
	}

	const blobHtml = new Blob([html], { type: TEXT_HTML_MIME_TYPE });
	const blobText = new Blob([text], { type: TEXT_PLAIN_MIME_TYPE });
	const clipboardItem = new ClipboardItem({
		[TEXT_HTML_MIME_TYPE]: blobHtml,
		[TEXT_PLAIN_MIME_TYPE]: blobText,
	});

	navigator.clipboard.write([clipboardItem]);

	if (successText) {
		toast.success(successText);
	}
}
